import { useState, useEffect } from 'react';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import MetaData from '../Layouts/MetaData';
import BackdropLoader from '../Layouts/BackdropLoader';

const ContactPageForm = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const { user } = useSelector((state) => state.user);
    const canEdit = user.role === "admin" || user.adminRole?.permissions?.pages?.edit;

    const [fields, setFields] = useState({
        heroTitle: "", heroTitleZh: "", heroSubtitle: "", heroSubtitleZh: "", companyName: "", address: "", addressZh: "",
        phone: "", whatsapp: "", email: "", facebook: "", instagram: "",
    });

    const set = (key) => (e) => setFields((prev) => ({ ...prev, [key]: e.target.value }));

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const { data } = await axios.get('/api/v1/contact-page');
                const { _id, createdAt, updatedAt, __v, ...rest } = data.page;
                setFields(rest);
            } catch (error) {
                enqueueSnackbar("Failed to load Contact page", { variant: "error" });
            } finally {
                setLoading(false);
            }
        };
        fetchPage();
        // eslint-disable-next-line
    }, []);

    const handleSave = async () => {
        setSaving(true);
        try {
            await axios.put('/api/v1/admin/contact-page', fields);
            enqueueSnackbar("Contact page updated", { variant: "success" });
        } catch (error) {
            enqueueSnackbar(error?.response?.data?.message || "Failed to save", { variant: "error" });
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <BackdropLoader />;

    return (
        <>
            <MetaData title="Admin: Edit Contact Page | 1313 Mart" />
            {saving && <BackdropLoader />}

            <div className="flex flex-col gap-4 bg-white rounded-lg shadow p-4 sm:p-6">
                <h1 className="text-lg font-medium uppercase">Edit Contact Us Page</h1>

                <TextField label="Hero Title" size="small" value={fields.heroTitle} onChange={set('heroTitle')} />
                <TextField label="Hero Title (中文 — optional)" size="small" value={fields.heroTitleZh} onChange={set('heroTitleZh')} />
                <TextField label="Hero Subtitle" size="small" multiline rows={2} value={fields.heroSubtitle} onChange={set('heroSubtitle')} />
                <TextField label="Hero Subtitle (中文 — optional)" size="small" multiline rows={2} value={fields.heroSubtitleZh} onChange={set('heroSubtitleZh')} />
                <TextField label="Company Name" size="small" value={fields.companyName} onChange={set('companyName')} />
                <TextField label="Address" size="small" multiline rows={2} value={fields.address} onChange={set('address')} />
                <TextField label="Address (中文 — optional)" size="small" multiline rows={2} value={fields.addressZh} onChange={set('addressZh')} />
                <TextField label="Phone" size="small" value={fields.phone} onChange={set('phone')} />
                <TextField label="WhatsApp Number" size="small" value={fields.whatsapp} onChange={set('whatsapp')} />
                <TextField label="Email" size="small" value={fields.email} onChange={set('email')} />
                <TextField label="Facebook URL" size="small" value={fields.facebook} onChange={set('facebook')} />
                <TextField label="Instagram URL" size="small" value={fields.instagram} onChange={set('instagram')} />

                {canEdit && (
                    <div className="flex justify-end">
                        <button onClick={handleSave} className="bg-primary-orange uppercase px-6 py-3 text-white font-medium rounded shadow hover:shadow-lg">Save Changes</button>
                    </div>
                )}
            </div>
        </>
    );
};

export default ContactPageForm;
